import LocalizedStrings from 'react-localization';

export const commonStrings = new LocalizedStrings({
  en: {
    common: {
      daysToTake: (n: number) => `This request requires ${n} ${n === 1 ? 'day' : 'days'} of leave.`,
      day: 'day',
      days: 'days',
      showAll: 'Show All',
      deactivate: 'Deactivate',
      reactivate: 'Reactivate',
      clockIn: 'Clock-In',
      clockOut: 'Clock-Out',
      time: 'Time',
      date: 'Date',
      submit: 'Submit',
      cancel: 'Cancel',
      create: 'Create',
      request: 'Request',
      add: 'Add',
      save: 'Save',
      back: 'Back',
      delete: 'Delete',
      reset: 'Reset',
      close: 'Close',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      mobileNumber: 'Mobile number',
      phoneNumber: 'Phone number',
      organizationId: 'Organization ID',
      home: 'Home',
      currencySymbol: '£',
      more: 'more',
      less: 'less',
      totalHasNotChanged: (total: string) => `The ${total.toLowerCase()} has not changed.`,
      hourShortHand: 'h',
      minuteShortHand: 'm',
      detailViewCommon: {
        estimatedCostExplanation:
          'At the moment, TimeShift doesn’t support full payroll functionality so additional context like overtime, contracted hours, tax or NI aren’t used in this estimation.',
        estimatedCost: 'Estimated Cost'
      },
      openMenu: 'Open menu',
      download: 'Download',
      closeModal: 'Close modal',
      roles: {
        staff: 'Staff',
        manager: 'Manager',
        admin: 'Admin'
      },
      pagination: {
        pageXOfY: (page: number, total: number) => `Page ${page} of ${total}`
      },
      search: 'Search',
      mandatory: (field: string) => `${field} is required`,
      ok: 'OK',
      toastNotifications: {
        success: 'Success!',
        error: 'Error!',
        repeatEmail: 'This email address is already being used by another account',
        repeatPhone: 'This phone number is already being used by another account'
      }
    }
  }
});

export function withCommon<Type>(strings: Type): Type & typeof commonStrings {
  return {
    ...strings,
    ...commonStrings
  };
}
